import { useCallback, useReducer } from "react";

const OPEN = "OPEN";
const CLOSE = "CLOSE";
const UPDATE = "UPDATE";
const RESET = "RESET";

const useDrawer = (initState) => {
  const initDrawerState = {
    isOpen: false,
    ...initState,
  };

  const [state, dispatchState] = useReducer((state, action) => {
    switch (action.type) {
      case OPEN:
        return { ...state, isOpen: true };
      case CLOSE:
        return { ...state, isOpen: false };
      case UPDATE:
        return { ...state, ...action.payload };
      case RESET:
        return initDrawerState;
      default:
        return state;
    }
  }, initDrawerState);

  const open = useCallback(
    () => dispatchState({ type: OPEN }),
    [dispatchState]
  );
  const close = useCallback(
    () => dispatchState({ type: CLOSE }),
    [dispatchState]
  );
  const reset = useCallback(
    () => dispatchState({ type: RESET }),
    [dispatchState]
  );
  const update = useCallback(
    (payload) => dispatchState({ type: UPDATE, payload }),
    [dispatchState]
  );

  return {
    open,
    close,
    update,
    reset,
    state,
    isOpen: state.isOpen,
  };
};

export default useDrawer;
